import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog, DialogContentText, DialogTitle } from '@mui/material';
const LoadingDialog = () => (_jsxs(Dialog, { open: true, children: [_jsx(DialogTitle, {}), _jsx(DialogContentText, { sx: { p: 2, textAlign: 'center' }, children: "Loading..." })] }));
export default LoadingDialog;
//# sourceMappingURL=LoadingDialog.js.map